import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class BpjsHistoryDeduction {
  history(id, year) {
    const params = {
      year: year,
    };

    const endPoint = `/bpjs/${id}/history?` + new URLSearchParams(params).toString();
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }
}

export default new BpjsHistoryDeduction();
